import { render } from "./TextSetting.vue?vue&type=template&id=482f3fa7"
import script from "./TextSetting.vue?vue&type=script&lang=js"
export * from "./TextSetting.vue?vue&type=script&lang=js"

import "./TextSetting.vue?vue&type=style&index=0&id=482f3fa7&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__